import { Box, Button, Typography } from '@mui/material';
import { FC } from 'react';
import { t } from 'i18next';
import { Info } from '@mui/icons-material';

import { CustomModal, FileUploader } from '@components';
import { theme } from '@store';
import { useImportProviderModal } from '@views/pages/Admin/Provider/hooks';
import { Select } from 'ui';

interface ImportBuildingModalProps {
  isOpen: boolean;
  handleClose: () => void;
}

export const ImportProviderModal: FC<ImportBuildingModalProps> = ({
  isOpen,
  handleClose,
}) => {
  const {
    practiceOptions,
    practiceId,
    handleChangePracticeId,
    handleDownloadCSVTemplate,
    isTemplateBtnDisabled,
    handleImportCsvFile,
    handleChangeFile,
    importError,
    file,
    handleCloseAction,
    isImportPending,
  } = useImportProviderModal(handleClose);

  return (
    <CustomModal
      isOpen={isOpen}
      onClose={handleCloseAction}
      title={t('adminPanel.providers.importModal.title')}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
        }}
      >
        <Select
          name='partner'
          size='medium'
          label={t('adminPanel.providers.importModal.practice')}
          required
          value={practiceId}
          onChange={handleChangePracticeId}
          options={practiceOptions}
        />

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <Typography variant='body2' sx={{ color: 'text.disabled' }}>
            {t('adminPanel.providers.importModal.templateText')}
          </Typography>
          <Button
            variant='outlined'
            onClick={handleDownloadCSVTemplate}
            disabled={isTemplateBtnDisabled}
            sx={{ width: 210 }}
          >
            {t('adminPanel.providers.importModal.downloadButton')}
          </Button>
        </Box>
        {importError.length > 0 && file && (
          <Box
            sx={{
              p: 2,
              color: theme.palette.common.white,
              background: theme.palette.error.main,
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Info />
              <Typography>
                {importError.length} formating errors found
              </Typography>
            </Box>
            <Box
              sx={{
                maxHeight: 100,
                overflowY: 'scroll',
              }}
            >
              {importError.map((item: string) => {
                return (
                  <Box key={item} sx={{ ml: 4 }}>
                    {item}
                  </Box>
                );
              })}
            </Box>
          </Box>
        )}

        <FileUploader setFile={handleChangeFile} file={file} />

        <Box
          sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, py: 3 }}
        >
          <Button variant='outlined' onClick={handleCloseAction}>
            {t('adminPanel.providers.importModal.cancel')}
          </Button>
          <Button
            variant='contained'
            onClick={handleImportCsvFile}
            disabled={!file || importError.length > 0}
            loading={isImportPending}
            sx={{ fontWeight: 'regular', fontSize: '1rem', color: 'white' }}
            color='secondary'
          >
            {t('adminPanel.providers.importModal.import')}
          </Button>
        </Box>
      </Box>
    </CustomModal>
  );
};
